/* eslint-disable arrow-body-style */
import React, { useMemo, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import actions from '@src/redux/actions';
import { LANGUAGE } from '@src/constants';
import { StyledLanguage, StyledLanguageSlider } from './index.styled';

const Language = ({ languageItem, onChangeLanguage, isSelected }) => {
  const { i18n } = useTranslation();
  const { language } = i18n;
  const dispatch = useDispatch();
  const { filterVoice } = useSelector((state) => state.voice);

  const handleChangeLanguage = () => {
    dispatch(
      actions.voice.changeFilterVoice({
        ...filterVoice,
        languageCode: languageItem.value,
      }),
    );
    onChangeLanguage(languageItem);
  };
  return (
    <StyledLanguage>
      <button
        className={`language-button ${isSelected ? 'selected-language' : ''}`}
        type="button"
        onClick={() => {
          handleChangeLanguage(languageItem);
        }}
      >
        <img
          className="language-button-img"
          src={languageItem.roundImage}
          alt=""
        />
        <span className="language-name">
          {language === 'vi' ? languageItem.label.vi : languageItem.label.en}
        </span>
      </button>
    </StyledLanguage>
  );
};

const LanguageSlider = ({ onChangeLanguage, currentLanguageValue }) => {
  const { languages } = useSelector((state) => state.language);
  const { i18n } = useTranslation();
  const { language: currLang } = i18n;
  const sliderRef = useRef(null);
  const { filterVoice } = useSelector((state) => state.voice);

  const sortedLanguages = useMemo(() => {
    return [...languages].sort((a, b) => {
      // Sort the current language to the first position
      if (a.value === currentLanguageValue) return -1;
      if (b.value === currentLanguageValue) return 1;

      if (a.rank !== b.rank) return a.rank - b.rank;

      if (currLang === LANGUAGE.VN)
        return a.label?.vi?.localeCompare(b.label?.vi);
      return a.label?.en?.localeCompare(b.label?.en);
    });
  }, [languages, filterVoice]);

  const handleChangeLanguage = (languageItem) => {
    onChangeLanguage(languageItem);

    // Cuộn về đầu slide
    if (sliderRef.current) {
      sliderRef.current.scrollTo({ left: 0, behavior: 'smooth' });
    }
  };
  return (
    <StyledLanguageSlider ref={sliderRef}>
      {sortedLanguages.map((item) => {
        return (
          <Language
            languageItem={item}
            onChangeLanguage={handleChangeLanguage}
            isSelected={currentLanguageValue === item.value}
          />
        );
      })}
    </StyledLanguageSlider>
  );
};

export default LanguageSlider;
